import { ConstructClassWithPrivateMembers } from '../helpers/ClassWithPrivateMembers';
import { GetPropertyDescriptor } from '../helpers/object-helpers';
const propertiesFunctionMap = new WeakMap();
export function GetOrCreatePropertiesFunctionMap(instance) {
    if (propertiesFunctionMap.has(instance)) {
        return propertiesFunctionMap.get(instance);
    }
    else {
        const map = new Map();
        propertiesFunctionMap.set(instance, map);
        return map;
    }
}
export function GetOrCreateInstanceFunctionProperty(instance, propertyKey, callback, functionsMap = GetOrCreatePropertiesFunctionMap(instance)) {
    if (functionsMap.has(propertyKey)) {
        return functionsMap.get(propertyKey);
    }
    else {
        const _callback = callback.bind(instance);
        functionsMap.set(propertyKey, _callback);
        return _callback;
    }
}
export const INSTANCE_PRIVATE = Symbol('instance-private');
export function ConstructInstance(instance, _instance, proto = instance.constructor) {
    ConstructClassWithPrivateMembers(instance, INSTANCE_PRIVATE);
    const privates = instance[INSTANCE_PRIVATE];
    privates.instance = _instance;
    privates.proto = proto;
    privates.functionsMap = GetOrCreatePropertiesFunctionMap(privates.instance);
}
export function InstanceGetPropertyDescriptor(instance, propertyKey) {
    return GetPropertyDescriptor(instance[INSTANCE_PRIVATE].proto, propertyKey);
}
export function InstanceProp(instance, propertyKey) {
    const privates = instance[INSTANCE_PRIVATE];
    const descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if (descriptor === void 0) {
        return void 0;
    }
    else {
        if (typeof descriptor.get === 'function') {
            return descriptor.get.call(privates.instance);
        }
        else if (typeof descriptor.set === 'function') {
            throw new Error(`The property ${String(propertyKey)} is a pure setter (not gettable)`);
        }
        else if (typeof descriptor.value === 'function') {
            return GetOrCreateInstanceFunctionProperty(privates.instance, propertyKey, descriptor.value, privates.functionsMap);
        }
        else {
            return descriptor.value;
        }
    }
}
export function InstanceAssign(instance, propertyKey, value) {
    const privates = instance[INSTANCE_PRIVATE];
    const descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if ((descriptor !== void 0) && (typeof descriptor.set === 'function')) {
        return descriptor.set.call(privates.instance, value);
    }
    else {
        privates.instance[propertyKey] = value;
    }
}
export function InstanceGet(instance, propertyKey) {
    const privates = instance[INSTANCE_PRIVATE];
    const descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if ((descriptor !== void 0) && (typeof descriptor.get === 'function')) {
        return descriptor.get.call(privates.instance);
    }
    else {
        throw new Error(`The property ${String(propertyKey)} is not a getter`);
    }
}
export function InstanceSet(instance, propertyKey, value) {
    const privates = instance[INSTANCE_PRIVATE];
    const descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if ((descriptor !== void 0) && (typeof descriptor.set === 'function')) {
        return descriptor.set.call(privates.instance, value);
    }
    else {
        throw new Error(`The property ${String(propertyKey)} is not a setter`);
    }
}
export function InstanceApply(instance, propertyKey, args = []) {
    const privates = instance[INSTANCE_PRIVATE];
    const descriptor = InstanceGetPropertyDescriptor(instance, propertyKey);
    if ((descriptor !== void 0) && (typeof descriptor.value === 'function')) {
        return descriptor.value.apply(privates.instance, args);
    }
    else {
        throw new Error(`The property ${String(propertyKey)} is not a function`);
    }
}
export class Instance {
    constructor(instance, proto) {
        ConstructInstance(this, instance, proto);
    }
    get instance() {
        return this[INSTANCE_PRIVATE].instance;
    }
    get proto() {
        return this[INSTANCE_PRIVATE].proto;
    }
    prop(propertyKey) {
        return InstanceProp(this, propertyKey);
    }
    assign(propertyKey, value) {
        return InstanceAssign(this, propertyKey, value);
    }
    call(propertyKey, ...args) {
        return this.apply(propertyKey, args);
    }
    get(propertyKey) {
        return InstanceGet(this, propertyKey);
    }
    set(propertyKey, value) {
        return InstanceSet(this, propertyKey, value);
    }
    apply(propertyKey, args) {
        return InstanceApply(this, propertyKey, args);
    }
}
//# sourceMappingURL=implementation.js.map